import { AcquisitionConstantsList } from 'app/utils/acquisitionConstants';
import React, { createContext, useContext } from 'react';

type AcquisitionConstantsContextType = {
  acquisitionConstantsByProfile: Record<string, AcquisitionConstantsList>;
  updateAcquisitionConstant: (
    region: string,
    acquisitionConstants: AcquisitionConstantsList
  ) => void;
};

const AcquisitionConstantsContext = createContext<AcquisitionConstantsContextType | undefined>(
  undefined
);

export const useAcquisitionConstants = () => {
  const context = useContext(AcquisitionConstantsContext);
  if (!context) {
    throw new Error('useAcquisitionConstants must be used within a AcquisitionConstantsProvider');
  }
  return context;
};

type AcquisitionConstantsProviderProps = {
  children: React.ReactNode;
  acquisitionConstantsByProfile: Record<string, AcquisitionConstantsList>;
  onUpdateAcquisitionConstant: (
    region: string,
    acquisitionConstants: AcquisitionConstantsList
  ) => void;
};

export const AcquisitionConstantsProvider: React.FC<AcquisitionConstantsProviderProps> = ({
  children,
  acquisitionConstantsByProfile,
  onUpdateAcquisitionConstant,
}) => {
  return (
    <AcquisitionConstantsContext.Provider
      value={{
        acquisitionConstantsByProfile,
        updateAcquisitionConstant: onUpdateAcquisitionConstant,
      }}
    >
      {children}
    </AcquisitionConstantsContext.Provider>
  );
};
